<template>
    <div>
    </div>
</template>

<script>
    export default {
        name: "Sakq",
        created() {
            const u = navigator.userAgent;
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isiOS) {
                window.location.href="https://apps.apple.com/cn/app/true/id1319212613";
            } else {
                window.location.href="https://fir.im/fut4";
            }
        },
    }
</script>

<style scoped>

</style>
